import {
  USER_ACCOUNT_DETAILS,
  USER_DETAILS,
} from 'constants/types';
import { LOGIN } from '../../constants/actionTypes';
import { ICustomObjectType } from 'constants/interfaces/GlobalInterfaces';

const initialUserState = {
  // userData: {} as Interfaces.IUser,
  userData: {} as unknown as ICustomObjectType,
  xiq_internal_user: false,
  isPremium: true,
  isClickedAmazing: false,
  isAssetBrowserPopupNotShowAgain: false,
  isTooltipAlreadyShowedFirstTime: false,
  isBrowseGillRoyFirstTime: false,
  showAssetBrowserPopup: false,
  has_share_profile_perm: false,
  has_daily_iq_perm: false,
  has_weekly_account_insight_perm: false,
  planType: '',
  accountDetails: {} as any,
};

// export const loginReducer = (state = initialUserState, action: Interfaces.IUserAction) => {
export const loginReducer = (state = initialUserState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case LOGIN.LOAD_SUCCESS:
      newState.userData = action.payload;
      newState.isBrowseGillRoyFirstTime = action.payload.first_login_workbench === 1 ? true : false;
      return newState;
    case LOGIN.TURN_OFF_FIRST_LOGIN:
      newState.userData.first_login_workbench = 0;
      return newState;
    case USER_DETAILS.LOAD:
      return newState;
    // When user clicks on Gill Roy "Amazing button call api and hide it"
    case USER_DETAILS.CLICKED_AMAZING:
      newState.isClickedAmazing = true;
      return newState;
    case USER_DETAILS.SET_DO_NOT_SHOW_ASSET_BROWSER_POPUP:
      newState.isAssetBrowserPopupNotShowAgain = true;
      return newState;
    case USER_DETAILS.SHOW_TOOL_TIP_FIRST_TIME:
      newState.showAssetBrowserPopup = true;
      newState.isTooltipAlreadyShowedFirstTime = true;
      return newState;

    case USER_DETAILS.HIDE_TOOL_TIP_FIRST_TIME:
      newState.showAssetBrowserPopup = false;
      return newState;

    case USER_DETAILS.SUCCESS:
      let userData: any = {};
      userData.firstName = action.payload.first_name;
      userData.lastName = action.payload.last_name;
      userData.userId = action.payload.user_id;
      userData.userEmail = action.payload.user_email;
      newState.userData = { ...newState.userData, ...action.payload, ...userData };
      newState.isAssetBrowserPopupNotShowAgain = !action.payload.show_msg;
      newState.xiq_internal_user = action.payload.xiq_internal_user;
      newState.has_share_profile_perm = action.payload.has_share_profile_perm;
      newState.has_daily_iq_perm = action.payload.has_daily_iq_perm;
      newState.has_weekly_account_insight_perm = action.payload.has_weekly_account_insight_perm;
      newState.planType = String(action.payload.plan_type).toUpperCase();
      return newState;

    case USER_DETAILS.RESET:
      return newState;

    case USER_DETAILS.SET_PLAN_TYPE:
      newState.planType = action.planType;
      return newState;

    // * User Account Details Reducer
    case USER_ACCOUNT_DETAILS.LOAD:
      return newState;
    case USER_ACCOUNT_DETAILS.SUCCESS:
      newState.accountDetails = action.payload;
      return newState;
    case USER_ACCOUNT_DETAILS.RESET:
      newState.accountDetails = {};
      return newState;
    case USER_ACCOUNT_DETAILS.FAIL:
      return newState;

    default:
      return newState;
  }
};
